import React from 'react';
import { Search, X, FileSpreadsheet, FileText } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';

const PatientsFilters = ({
  searchTerm,
  setSearchTerm,
  filterEnviado,
  setFilterEnviado,
  filterExamen,
  setFilterExamen,
  filterInstitucion,
  setFilterInstitucion,
  filterDateStart,
  setFilterDateStart,
  filterDateEnd,
  setFilterDateEnd,
  examTypes,
  institutions,
  onClearFilters,
  onExportExcel,
  onExportPDF,
  hasActiveFilters
}) => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
          <Input
            placeholder="Buscar por nombre, teléfono o NIT..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10 bg-slate-50 h-11"
            data-testid="search-patients"
          />
        </div>
        <div className="flex gap-2">
          <Button
            onClick={onExportExcel}
            variant="outline"
            className="border-emerald-300 text-emerald-600 hover:bg-emerald-50"
            data-testid="export-excel-button"
          >
            <FileSpreadsheet className="w-4 h-4 mr-2" />
            Excel
          </Button>
          <Button
            onClick={onExportPDF}
            variant="outline"
            className="border-red-300 text-red-500 hover:bg-red-50"
            data-testid="export-pdf-button"
          >
            <FileText className="w-4 h-4 mr-2" />
            PDF
          </Button>
        </div>
      </div>
      
      <div className="flex flex-wrap gap-3 items-end">
        <div className="flex-1 min-w-[140px]">
          <Label className="text-xs text-slate-500 mb-1 block">Estado</Label>
          <Select value={filterEnviado} onValueChange={setFilterEnviado}>
            <SelectTrigger className="bg-slate-50">
              <SelectValue placeholder="Todos" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todos</SelectItem>
              <SelectItem value="true">Enviados</SelectItem>
              <SelectItem value="false">Pendientes</SelectItem>
            </SelectContent>
          </Select>
        </div>
        
        <div className="flex-1 min-w-[140px]">
          <Label className="text-xs text-slate-500 mb-1 block">Institución</Label>
          <Select value={filterInstitucion} onValueChange={setFilterInstitucion}>
            <SelectTrigger className="bg-slate-50" data-testid="filter-institucion">
              <SelectValue placeholder="Todas" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todas</SelectItem>
              {institutions?.map((inst) => (
                <SelectItem key={inst} value={inst}>{inst}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        
        <div className="flex-1 min-w-[140px]">
          <Label className="text-xs text-slate-500 mb-1 block">Tipo Examen</Label>
          <Select value={filterExamen} onValueChange={setFilterExamen}>
            <SelectTrigger className="bg-slate-50">
              <SelectValue placeholder="Todos" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todos</SelectItem>
              {examTypes.map((exam) => (
                <SelectItem key={exam} value={exam}>{exam}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        
        <div className="flex-1 min-w-[140px]">
          <Label className="text-xs text-slate-500 mb-1 block">Desde</Label>
          <Input
            type="date"
            value={filterDateStart}
            onChange={(e) => setFilterDateStart(e.target.value)}
            className="bg-slate-50"
          />
        </div>
        
        <div className="flex-1 min-w-[140px]">
          <Label className="text-xs text-slate-500 mb-1 block">Hasta</Label>
          <Input
            type="date"
            value={filterDateEnd}
            onChange={(e) => setFilterDateEnd(e.target.value)}
            className="bg-slate-50"
          />
        </div>
        
        {hasActiveFilters && (
          <Button 
            variant="outline" 
            size="sm"
            onClick={onClearFilters}
            className="border-slate-300 text-slate-600"
          >
            <X className="w-4 h-4 mr-1" />
            Limpiar
          </Button>
        )}
      </div>
    </div>
  );
};

export default PatientsFilters;
